export default __webpack_public_path__ + "assets/_Chapters/Nachhaltigkeit/ll-c-certification.webp";